import axios from 'axios';

// TODO TRANSLATION: add query translation for products
export const getSearchedProducts = (query, lang) =>
   lang === 'eng' //
      ? axios.get(`/kns/products?query=${query}`)
      : axios.get(`/kns/products?query=${query}`);

export const getSearchedPriceList = (query) => axios.get(`/kns/price-list?query=${query}`);

export const getSearchedInstructions = (query) => axios.get(`/kns/instructions?query=${query}`);

export const getSearchedNews = (query) => axios.get(`/kns/news?query=${query}`);

export const decodeHtmlEntities = (str) => {
   if (typeof str !== 'string') return str;
   return str
      .replace(/&#8211;/g, '-')
      .replace(/&#8212;/g, '-')
      .replace(/&#8217;/g, "'")
      .replace(/&#039;/g, "'")
      .replace(/&quot;/g, '"')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>');
};

export const buildTreeFromFlatItems = (flatItems) => {
   if (!Array.isArray(flatItems)) return [];
   const itemMap = {};
   const rootItems = [];

   flatItems.forEach((raw) => {
      const rawTitle = typeof raw.title === 'object' ? raw.title?.rendered : raw.title;
      const formatted = {
         ...raw,
         title: decodeHtmlEntities(rawTitle),
         children: []
      };
      itemMap[raw.id] = formatted;
   });

   flatItems.forEach((raw) => {
      const item = itemMap[raw.id];
      if (raw.parent && itemMap[raw.parent]) {
         itemMap[raw.parent].children.push(item);
      } else {
         rootItems.push(item);
      }
   });

   const cleanupEmptyChildren = (items) => {
      items.forEach((item) => {
         if (item.children && item.children.length > 0) {
            cleanupEmptyChildren(item.children);
         } else {
            delete item.children;
         }
      });
      return items;
   };

   return cleanupEmptyChildren(rootItems);
};

const MENU_ITEM_FIELDS =
   'id,title,parent,url,attr_title,description,object_id,object_slug,type,object';

export const fetchMenuItemsTree = async (menuId) => {
   const res = await axios.get(
      `/wp/v2/menu-items?menus=${menuId}&per_page=100&_fields=${MENU_ITEM_FIELDS}`
   );
   const items = buildTreeFromFlatItems(res.data);
   return { ...res, data: { items } };
};

export const getCatalogCategoriesNavItems = (lang) => fetchMenuItemsTree(lang === 'eng' ? 440 : 74);

export const getCatalogModelsNavItem = (lang) => fetchMenuItemsTree(lang === 'eng' ? 441 : 100);

export const getCatalogTagsNavItem = (lang) => fetchMenuItemsTree(lang === 'eng' ? 809 : 99);

export const fetchSingleProductNavItemsByMenuId = async (menuId) => {
   const mainRes = await axios.get(
      `/wp/v2/menu-items?menus=${menuId}&per_page=100&_fields=${MENU_ITEM_FIELDS}`
   );
   const rawItems = Array.isArray(mainRes.data) ? mainRes.data : mainRes.data?.items;

   if (!rawItems?.length) {
      return { data: { items: [] } };
   }

   const mainTree = buildTreeFromFlatItems(rawItems);

   const updatedItems = await window.Promise.all(
      mainTree.map(async (rawItem) => {
         const rawTitle =
            typeof rawItem.title === 'object' ? rawItem.title?.rendered : rawItem.title;
         const item = {
            ...rawItem,
            title: decodeHtmlEntities(rawTitle)
         };

         const subMenuId = rawItem.description?.trim() || rawItem.attr_title?.trim();

         if (subMenuId) {
            const subRes = await axios.get(
               `/wp/v2/menu-items?menus=${subMenuId}&per_page=100&_fields=${MENU_ITEM_FIELDS}`
            );
            if (Array.isArray(subRes?.data) && subRes.data.length > 0) {
               return {
                  ...item,
                  children: buildTreeFromFlatItems(subRes.data)
               };
            }
         }

         return item;
      })
   );

   return {
      data: {
         items: updatedItems
      }
   };
};

export const getSingleProductNavItemsPol = () => fetchSingleProductNavItemsByMenuId(4695);

export const getSingleProductNavItemsEng = () => fetchSingleProductNavItemsByMenuId(4731);

export const getSingleProductNavItemsUkr = () => fetchMenuItemsTree(4436);

export const getSingleProductNavItemsGer = () => fetchMenuItemsTree(4489);
